module.exports = __webpack_public_path__ + "img/type3_bg3.7a227c3e.png";